export interface Permission {
  id: number
  name: string
  guard_name: string
  created_at: string
  updated_at: string
}

export function normalizePermissionName(permissionName: string) {
  return permissionName.trim().replace(/^lop:/, '')
}
